import { render, staticRenderFns } from "./ExamQuestionsModal.vue?vue&type=template&id=2e8e7ef0&scoped=true&"
import script from "./ExamQuestionsModal.vue?vue&type=script&lang=js&"
export * from "./ExamQuestionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExamQuestionsModal.vue?vue&type=style&index=0&id=2e8e7ef0&prod&scoped=true&lang=css&"
import style1 from "./ExamQuestionsModal.vue?vue&type=style&index=1&id=2e8e7ef0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e7ef0",
  null
  
)

export default component.exports